<script>

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import { useToast } from "vue-toastification";7
import { format } from 'date-fns'

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
Fancybox.bind("[data-fancybox]", {
  // Your options go here
});

import { Container, Draggable } from "vue3-smooth-dnd";
 

//store
import {useSelectedItemStore} from "@/stores/selectedItem";

//components
import MyPagination from '@/components/SystemElements/PaginationV2.vue'
import MyCountRecords from '@/components/SystemElements/CountRecordsOptionsV2.vue'
import LoadingScreen from '@/components/General/LoadingScreen'
import CheckboxToggle from '@/components/General/CheckboxToggle'
import Alert from '@/components/General/Alert'
import CheckboxTableSelectOne from '@/ui/CheckboxTableSelectOne'
import CheckboxTableSelectAll from '@/ui/CheckboxTableSelectAll'
import ButtonTableResetAllSelected from '@/ui/ButtonTableResetAllSelected'
import UserCircle from '@/ui/UserCircle'

import ArticleDelete from '@/components/Core/Articles/ArticleDelete.vue'

//data
import { getArticles, unlockArticle, changeStateArticle, reOrderArticle } from '@/services/serviceArticle';
import { getCategoryOptions } from '@/services/serviceArticleCategory';

//utils
import { zistiDiff } from '@/utils/auditLogs';

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

export default {
	setup() {
		let selectedItemStore = useSelectedItemStore();
		const allSelectedItems = selectedItemStore.getAllSelectedItems;

		const toast = useToast();
		return { toast, allSelectedItems, selectedItemStore }
	},
	name: 'Articles',
	mixins: [ MixinGeneralFunct ],
	components: {
		ArticleDelete
		,MyPagination,MyCountRecords
		,Container, Draggable
		,LoadingScreen
		,CheckboxToggle
		,Alert
		,CheckboxTableSelectOne
		,CheckboxTableSelectAll
		,ButtonTableResetAllSelected
		,UserCircle
	},
	props: {'auth':Object, 'secData':Object, 'params':Object},
	data() {
		return {
			metaData:[],
            
            isLoading:true,
			errorStatus:'',

            totalCount:0,
            dataList:[],

			selectedFilterText:'',
            selectedCategory:'',
            selectedArticleId:'',

			optionsCategories:[],

			selectedPage:1,
			selectedRecords:10,
			selectedCol:'a.id',
			selectedSort:'desc',
			
			checkAllItems:false,
					
			showFilter:false,
			filterExtended:true,
			
			showedHelpbox:false,

			modalDelete:{},
			modalDeleteId:'',

			format
		}
	},
	
	mounted:function(){
		this.modalDeleteId = `modal${this.getRandomInt(999999999)}`;
		this.onLoadPage();
	},
	
	methods: {

		onLoadPage:function(){
			
			//show loader
			this.isLoading=true
			
			getArticles({filterText: this.selectedFilterText, filterCategory: this.selectedCategory, orderCol: this.selectedCol, orderSort: this.selectedSort, page: this.selectedPage, records: this.selectedRecords}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					this.dataList = response.results;
					this.metaData = response.metaData;
					this.totalCount = response.totalCount;
				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});

			getCategoryOptions().then(response => {
				this.optionsCategories=response.options;
			});
		
		},
		
				
		//odomknutie zaznamu
		onUnLock:function(articleId){
			this.cSession();
			this.isLoading=true
			unlockArticle({articleId}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasUnlocked'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeUnlocked'));
					}else if(response.resCode==2){
						this.toast.error(this.$t('msgCore.dataWasNotUnlocked'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
					
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},
				
		//(od)oznacenie vsetkych poloziek
		handleSelectedItems:function(e){
			this.dataList=e;
		},
		
		
		//radenie zoznamu - orders by
		orderByCol:function(col){
			
			if(col === this.selectedCol) {
				if(col=='a.ordering'){
					this.selectedSort==='asc';
				}else{
					this.selectedSort = this.selectedSort==='asc'?'desc':'asc';
				}
				
			}
			this.selectedCol = col;
			
			this.onLoadPage();
		},
		
		
		//active menu
		isActive: function (col) {
			return this.selectedCol === col;
		},
		isAsc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'asc'){
				return true;
			}
		},
		isDesc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'desc'){
				return true;
			}
		},
		

		//zobrazi filtre
		showFilters: function(){
			if(!this.showFilter) {
				this.showFilter = true;
			}else{
				this.showFilter = false;
			}
		},
		
		//vycisti text filter
		resetTextFilter: function(){
			this.selectedFilterText = '';
			this.onLoadPage();
		},
		
		// zobrazi napovedu
		showHelpbox: function(){
			if(!this.showedHelpbox) {
				this.showedHelpbox = true;
			}else{
				this.showedHelpbox = false;
			}
		},
		// systemove funkcie k zoznamu KONIEC
		
		
				
		//modal box article delete
		loadModalFormArticleDelete:function(recordID){
			this.cSession();
			this.selectedArticleId=String(recordID);
			this.modalDelete = new bootstrap.Modal(document.getElementById(this.modalDeleteId), {backdrop:'static'})
			this.modalDelete.show();
		},
		
		

		//zmena zaznamu
		onChangeItem() {
			this.onLoadPage();
			this.selectedArticleId='';
		},

		//vyber stranky v strankovaci
		onChangePage(selectedPage) {
			this.selectedPage=selectedPage
			this.onLoadPage();
		},

		//vyber poctu zaznamov
		onChangeRecords(selectedCount) {
			this.selectedPage=1;
			this.selectedRecords=selectedCount
			this.onLoadPage();
		},
		
		//zmena stavu
		onChangeState:function(e){

			this.cSession();			
			this.isLoading=true
			changeStateArticle({articleId:e.id,state:e.state}).then(response => {

				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						zistiDiff({state:e.state},{state:response.newState},e.id,2);
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

		onDrop(dropResult){
			//console.log(dropResult)
			this.dataList = this.applyDrag(this.dataList, dropResult);
		},

		applyDrag(arr, dragResult) {
			
			const { removedIndex, addedIndex, payload } = dragResult;
			if (removedIndex === null && addedIndex === null) return arr;

			const result = [...arr];
			let itemToAdd = payload;

			const removedIndex1 = removedIndex-1;
			const addedIndex1 = addedIndex-1;
			
			//najdem id pre removedIndex1
			const idItemRemove = arr[removedIndex1].id;
			
			const orderingItemAdded = arr[addedIndex1].ordering;
			
						
			this.cSession();

			reOrderArticle({removedIndex1,addedIndex1,idItemRemove,orderingItemAdded}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			//radenie pre js
			if (removedIndex1 !== null) {
				itemToAdd = result.splice(removedIndex1, 1)[0];
			}

			if (addedIndex1 !== null) {
				result.splice(addedIndex1, 0, itemToAdd);
			}

			return result;
		},

		
		
	},	
	
			
	watch: {
		dataList() {
			//oznacenie vybranych poloziek
			for(let i = 0; i < this.dataList.length; i++){
				if(this.allSelectedItems.indexOf(this.dataList[i].id)>=0){
					this.dataList[i].selectedId=true;
				}
			}
		},
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>
		
	<LoadingScreen :isLoading="isLoading"></LoadingScreen>
	
	<div v-on:click="cSession()" id="version" class="version"><p>{{metaData.version}}</p></div>

		<div v-if="metaData.modulAccess" > 
					
            <div class="row">
                <div class="col-12">
                                    
					<div class="row">
						<div class="col-6">
							<h5>{{ $t('msgCore.Articles') }} </h5>	 
						</div> 

						<div class="col-6 right">
							<router-link :to="('/article/new')"><button type="button" :disabled="!auth.articlesNew" :title="$t('msgCore.btnAdd')" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-plus"></i> {{$t('msgCore.btnAdd') }}</button></router-link>
						</div> 
					</div>

					<!-- filters basic -->
					<div class="row">
						<div class="col-md-4 col-12">
							<div class="input-group">
								<button type="button" :title="$t('msgCore.btnFilter')" class="btn btn-info btn-sm my-btn" v-on:click="showFilters()">
									<span v-if="filterExtended">
										<i v-if="!showFilter" class="smire-icon fas fa-search-plus"></i> 
										<i v-else class="smire-icon fas fa-search-minus"></i>
									</span>
									<span v-else>
										<i class="smire-icon fas fa-search"></i> 
									</span>
									{{ $t('msgCore.btnFilter') }}
								</button>
								<input type="text" class="form-control form-control-sm" v-model='selectedFilterText' :placeholder="$t('msgCore.searchTitle')" v-on:change="onLoadPage()">
								<button type="button" :title="$t('msgCore.btnStorno')" class="btn btn-outline-info btn-sm my-btn" v-on:click="resetTextFilter()">
									<i class="smire-icon fas fa-times"></i>
								</button>
							</div>
						</div>
					</div>
					

					<!-- filters extended -->
					<div v-show="showFilter && filterExtended" class="row">
						<div class="col-md-4 col-12 mt-1">
							<div class="input-group">
						
								<select v-model='selectedCategory' class="form-select form-select-sm" v-on:change="onLoadPage()">
									<option value="">{{ $t('msgCore.selectCategory') }}</option>
									<option v-for="(options) in optionsCategories" :value="options.value" :key="options.value">{{ options.title }}</option>
								</select>
								
							</div>
						</div>				
					</div>
                        
                    
                </div>
            </div>	



			

            <!-- zakladny zoznam -->
            <div v-if="totalCount>0">
            
                    <div class="row">
                        <div class="col-12">
        
                            <div class="table-responsive">
                                <table class="table table-hover table-sm">
                                
									<Container @drop="onDrop" drag-handle-selector=".column-drag-handle" orientation="vertical">
                                    <thead>
                                        <tr>
											
											<th class="orderBy" v-on:click="orderByCol('a.ordering')" :class="{ active: isActive('a.ordering'), asc: isAsc('a.ordering'), desc: isDesc('a.ordering')}">Ord.</th>

                                            <th class="orderBy" v-on:click="orderByCol('a.id')" :class="{ active: isActive('a.id'), asc: isAsc('a.id'), desc: isDesc('a.id')}">ID</th>
                                        
                                            <th width="10" class="align-middle">
												<CheckboxTableSelectAll :dataList="dataList" :selectedItemStore="selectedItemStore" :allSelectedItems="allSelectedItems" @changeSelected="handleSelectedItems"/>
											</th>
                                        
                                            <th>
                                                {{$t('msgCore.Action')}}
                                            </th>
                                            
											<th colspan="2">{{$t('msgCore.State')}}</th>
                                            
                                            <th>{{ $t('msgCore.Highlighted') }}</th>
                                            
                                            <th>{{$t('msgCore.Title')}}</th>
                                            
                                            <th>{{$t('msgCore.Preview')}}</th>
                                            
                                            <th>{{$t('msgCore.Category')}}</th>
                                            
                                            <th>{{$t('msgCore.publish_up')}}</th>
                                            
                                            <th>{{$t('msgCore.publish_down')}}</th>
                                            
                                           
											<th class="orderBy" v-on:click="orderByCol('a.created')" :class="{ active: isActive('a.created'), asc: isAsc('a.created'), desc: isDesc('a.created')}">{{$t('msgCore.Created')}}</th>
                                            
                                            <th>{{$t('msgCore.Modified')}}</th>
                                            
                                            <th>{{$t('msgCore.Language')}}</th>	
                                            
                                            <th>{{$t('msgCore.AccessLevel')}}</th>									
                                        </tr>
                                    </thead>
                                   
                                    <Draggable tag="tr" draggable=".fa-ellipsis-v" v-for="(basicObj) in dataList" :key="basicObj.id" :drag-begin-delay="200">
		
										<td><div class="column-drag-handle box-flex" v-if="selectedCol=='a.ordering'" style="cursor:move;width: 100%;height: 26px;background: #f2f2f2;"><i class="fas fa-ellipsis-v"></i></div></td>

                                        <td class="">{{ basicObj.id }}</td>
                                        
                                        <td class="align-middle">
											<CheckboxTableSelectOne :dataList="dataList" :id="basicObj.id" :selectedId="basicObj.selectedId" :selectedItemStore="selectedItemStore" :allSelectedItems="allSelectedItems" @changeSelected="handleSelectedItems" />
                                        </td>
                                    
                                        <td>
                                            <div class="input-group">	
                                                
                                                <button v-if="basicObj.isCheckedOut" type="button" :disabled="!auth.articlesUnlock" v-on:click="onUnLock(basicObj.id)" v-bind:title="basicObj.checkedOutName+', '+basicObj.isCheckedOutDate" class="btn btn-sm"><i class="smire-icon fas fa-lock"></i></button>
                                                
                                                <div class="btn-group">
													<button  v-if="basicObj.state==3" type="button" :disabled="!auth.articlesDelete" v-on:click="loadModalFormArticleDelete(basicObj.id)" :title="$t('msgCore.btnDelete')" class="btn btn-danger btn-sm"><i class="smire-icon fas fa-trash-alt"></i></button>
                                                </div>	
                                                
                                            </div>	
                                        </td>
                                        
                                        <td  :title="$t('msgCore.' + basicObj.state_name)">
											<i class="fas fa-circle" :class="{'text-success':basicObj.state==1,'text-danger':basicObj.state==2,'text-warning':basicObj.state==3}" ></i>
										</td>	

										<td>
											<CheckboxToggle v-if="basicObj.state!=3" :key="basicObj.id" :isDisabled="(!auth.articlesChangeState)" :data="basicObj" @onClick="onChangeState"></CheckboxToggle>
										</td>

                                        <td>
											<i v-if="basicObj.selected" class="fas fa-star text-warning"></i>
											<i v-else class="far fa-star text-gray"></i>
                                        </td>
                                        
                                        <td>
											<router-link v-if="auth.articlesEdit" :to="`/article/${basicObj.id}/edit`">{{ basicObj.title }}</router-link><span v-else>{{ basicObj.title }}</span>
										</td>
                                                  
                                        <td>
                                            <a v-if="basicObj.photoData" class="fancybox" data-fancybox="gallery" :href="basicObj.photoDataOrigo"><img :src="basicObj.photoData" style="height:30px;"></a>
                                        </td>
                                        
                                        <td>{{ basicObj.category_name }}</td>
                                        
                                        <td><span v-if="basicObj.publish_up && basicObj.publish_up !='0000-00-00 00:00:00'">{{format(new Date(basicObj.publish_up), 'dd.MM.yyyy HH:mm')}}</span></td>
										<td><span v-if="basicObj.publish_down && basicObj.publish_down !='0000-00-00 00:00:00'">{{format(new Date(basicObj.publish_down), 'dd.MM.yyyy HH:mm')}}</span></td>
										
                                        <td>
											<UserCircle :firstName="basicObj.creatorFirstName" :surName="basicObj.creatorSurName" :color="basicObj.creatorColor" :date="basicObj.created"/>
                                        </td>

										<td>
											<UserCircle :firstName="basicObj.editorFirstName" :surName="basicObj.editorSurName" :color="basicObj.editorColor" :date="basicObj.modified"/>
                                        </td>
                                        
                                        
                                        <td :title="$t('msgCore.'+basicObj.languageName)" >{{ basicObj.language }}</td>
                                    
                                        <td>{{ basicObj.access_name }}</td>
                                        
                                        
                                    </Draggable>
									
									
                                </Container>     

                                
                                </table>	
                            </div>		
                        
                        </div>
                    </div>

                    <div class="row row-pagination">
                        <div class="col-6 col-md-3 col-lg-2">
                            <MyCountRecords :selectedRecords="selectedRecords" @onSelectRecords="onChangeRecords"></MyCountRecords>
                        </div>
                     
                        <div class="col-6 col-md-3 col-lg-2 box-flex">
							<ButtonTableResetAllSelected :dataList="dataList" :totalCount="totalCount" :selectedItemStore="selectedItemStore" :allSelectedItems="allSelectedItems"  @changeSelected="handleSelectedItems" />
                        </div>
                        
                        <div class="col-12 col-md-6 col-lg-8">	
							<MyPagination :selectedRecords="selectedRecords" :totalCount="totalCount" :selectedPage="selectedPage" @onSelectPage="onChangePage"></MyPagination>
						</div>
                    </div>	
                    
                
            </div>	
            
            <div v-else class="row">
                <div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />
                </div>							
            </div>
            
        </div>	
        
        <div v-else class="container-fluid">
            <div class="row">
                <div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.accessDenied')" />
                </div>
            </div>
        </div>

        <div v-if="errorStatus" class="container-fluid">
            <div class="row">
                <div class="col-12 mt-3">
					<Alert type="danger" :label="errorStatus" />
                </div>
            </div>
        </div>
	
		
		<ArticleDelete :auth="auth" :secData="secData" :articleId="selectedArticleId" @changeRecord="onChangeItem" :modalObject="modalDelete" :modalId="modalDeleteId"></ArticleDelete>
	</div>
		
</template>


<style lang="css" scoped>


.smooth-dnd-container.vertical > .smooth-dnd-draggable-wrapper {
  overflow: hidden;
  display: revert;
}

  
</style>